import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_TOKEN } from '../../simulation';
import { ApiConstant } from '../../types';
import { AddAdminRequest } from '../types';

@Injectable({
    providedIn: 'root',
})
export class OrganizationService {
    constructor(@Inject(API_TOKEN) private apiConstants: ApiConstant, private httpClient: HttpClient) {}

    getOrganizationsById(id: any): Observable<any> {
        return this.httpClient.post(`${this.apiConstants.endpoint}/Organization/Get`, id);
    }

    getAllOrganizations(includeDisable?: boolean): Observable<any> {
        let params = new HttpParams().set('IncludeDisabled', includeDisable ? 'true' : 'false');
        return this.httpClient.get(`${this.apiConstants.endpoint}/Organization/Gets`, {
            params,
        });
    }

    getBySimulationId(simulationId: any): Observable<any> {
        return this.httpClient.post(`${this.apiConstants.endpoint}/Organization/GetBySimulationId`, {
            simulationId: simulationId,
        });
    }

    createOrganization(data: any): Observable<any> {
        return this.httpClient.post(`${this.apiConstants.endpoint}/Organization/Add`, data);
    }

    updateOrganization(id: any, data: any): Observable<any> {
        return this.httpClient.put(`${this.apiConstants.endpoint}/Organization/Update/${id}`, data);
    }

    deleteOrganization(id: any): Observable<any> {
        return this.httpClient.delete(`${this.apiConstants.endpoint}/Organization/Delete/${id}`);
    }

    getMyOrganization(): Observable<any> {
        return this.httpClient.get(`${this.apiConstants.endpoint}/Organization/GetMyOrganization`);
    }

    getOrganizationAdmins(id: any): Observable<any> {
        return this.httpClient.get(<any>`${this.apiConstants.endpoint}/Organization/GetAdmins/${id}`);
    }

    checkAdminByEmail(organizationId: string, email: string): Observable<any> {
        return this.httpClient.get(`${this.apiConstants.endpoint}/Organization/CheckAdminByEmail/${organizationId}/${email}`);
    }

    inviteAdmin(organizationId: number, request: AddAdminRequest): Observable<any> {
        return this.httpClient.post(`${this.apiConstants.endpoint}/Organization/InviteAdmin/${organizationId}`, request);
    }

    removeAdmin(participantId: number): Observable<any> {
        return this.httpClient.delete(`${this.apiConstants.endpoint}/Organization/RemoveAdmin/${participantId}`);
    }
}
